export enum ActionCenterTaskType {
	PACK_CONVERSION = 'PACK_SIZE_CONVERSIONS',
	DIRECT_DEALS = 'DIRECT_DEALS',
	CONTRACT_LOADING = 'CONTRACT_LOADING',
}

export type ActionCenterTask = {
	task: ActionCenterTaskType
	title: string
	subtitle: string
	actionLabel: string
	step: number
	completed: boolean
	isLoading: boolean
}
